import dynamic from 'next/dynamic';
import { TemplateType } from 'types/cms';

/*
In VSCODE : ctlr + maj + p, then type "sort line ascending"
thx ⬇️⬇️⬇️
*/

const TEMPLATE_MAPPER: Record<string, TemplateType<any>> = {
  // TODO add possibles routes for these components in comments
  Admin: dynamic(() => import('./Form/Admin')),
  AdventurePass: dynamic(() => import('./SeasonPass')),
  Alterators: dynamic(() => import('./Alterators/list')),
  AlteratorsDetails: dynamic(() => import('./Alterators/details')),
  CardExchange: dynamic(() => import('./CardExchange/error')),
  CardExchangeDetails: dynamic(() => import('./CardExchange/success')),
  Cards: dynamic(() => import('./Cards/list')),
  CardsDetails: dynamic(() => import('./Cards/details')),
  CardsLists: dynamic(() => import('./CartaMundi/CardsLists')),
  CardsListsView: dynamic(() => import('./CartaMundi/CardsListView')),
  ContactUs: dynamic(() => import('./Form/ContactUs')),
  Content: dynamic(() => import('./Content')),
  Decks: dynamic(() => import('./Decks/list')),
  DecksCreate: dynamic(() => import('./Decks/create')),
  DecksDetails: dynamic(() => import('./Decks/details')),
  DecksMultiscan: dynamic(() => import('./Multiscan/Decks')),
  EventLocator: dynamic(() => import('./Locator/Events')),
  Events: dynamic(() => import('./Events/list')),
  EventsAdmin: dynamic(() => import('./Events/admin/index')),
  EventsAdminUsers: dynamic(() => import('./Events/admin/users/index')),
  EventsCreate: dynamic(() => import('./Events/create')),
  EventsDetails: dynamic(() => import('./Events/details')),
  Factions: dynamic(() => import('./Factions/home')),
  FactionsDetails: dynamic(() => import('./Factions/details')),
  Form: dynamic(() => import('./Form')),
  Friends: dynamic(() => import('./profile/Friends')),
  MultiscanCollection: dynamic(() => import('./Multiscan/Collection')),
  MultiscanPartner: dynamic(() => import('./Multiscan/Partner')),
  MyExchanges: dynamic(() => import('./profile/MyExchanges')),
  MyExchangesDetails: dynamic(() => import('./profile/MyExchanges/details')),
  News: dynamic(() => import('./News/list')),
  NewsDetails: dynamic(() => import('./News/details')),
  Notifications: dynamic(() => import('./profile/Notifications')),
  Printing: dynamic(() => import('./Printing')),
  PrintingCheckout: dynamic(() => import('./Printing/checkout')),
  PrintingDetails: dynamic(() => import('./Printing/details')),
  PrintingTracking: dynamic(() => import('./Printing/tracking')),
  Profile: dynamic(() => import('./profile')),
  ProfileDetails: dynamic(() => import('./profile')),
  ScanDetails: dynamic(() => import('./Scan')),
  ShopProfile: dynamic(() => import('./profile/Shop')),
  StoreLocator: dynamic(() => import('./Locator/Shop')),
  TabbedContent: dynamic(() => import('./TabbedContent')),
  WalletPayoutTransactionsDetails: dynamic(
    () => import('./Form/forms/Admin/Wallet/History/details/WalletPayoutDetail'),
  ),
  WalletTopupTransactionsDetails: dynamic(() => import('./Form/forms/Admin/Wallet/History/details/WalletTopupDetail')),

  CardsMarketDetails: dynamic(() => import('./Form/forms/Admin/Wallet/History/details/CardsMarketDetails')),
};

export default TEMPLATE_MAPPER;
